export const CUSTOMER_AGREEMENTS_API = '/platform/v1/customers/agreement/sessions'

export const PARAMS = {
  REFERENCE: 'session',
  REDIRECT: 'redirectUri',
  PRIMARY_COLOR: 'primaryColor',
  IS_DARK_MODE: 'isDarkMode',
  IS_BRANDED: 'isBranded',
} as const

export const EmbeddedAgreementPayloadStatuses = {
  SIGNED: 'SIGNED',
} as const

export const EmbeddedUseCases = {
  FIAT: 'FIAT',
  CRYPTO: 'CRYPTO',
  BOTH: 'BOTH',
}

export const EmbeddedAgreementStatuses = {
  ...EmbeddedAgreementPayloadStatuses,
  PENDING: 'PENDING',
  EXPIRED: 'EXPIRED',
} as const

export const SessionStatusMapping = {
  EXPIRED: 'expired',
  SIGNED: 'signed',
} as const

export const SessionStatusCodes = {
  ...SessionStatusMapping,
  NO_REFERENCE: 'noReference',
  QUERY_ERROR: 'queryError',
  NO_AGREEMENTS: 'noAgreements',
} as const

export const VARIANT_ACCOUNT_REFERENCE = {
  dakota: '48f6796c-daf5-41f8-936f-55bf684497b9',
}
